import { Info } from "lucide-react";

import { Tooltip } from "@/design-system/components/Tooltip/Tooltip";
import { twMerge } from "@/design-system/twMerge";
import { useAccountMetadataForManagement } from "@/MasqueradePage/useAccountMetadataForManagement";
import { useAccountEntitlementsForManagement } from "@/entitlements/queries/useAccountEntitlementsForManagement";

const OverrideList = ({ keys }: { keys: string[] }) => (
  <ul className="list-none">
    {[...keys].sort().map((key) => (
      <li key={key} className="font-mono break-all">
        {key}
      </li>
    ))}
  </ul>
);

type ActiveOverridesInfoProps = {
  className?: string;
};

export const ActiveOverridesInfo = ({
  className,
}: ActiveOverridesInfoProps) => {
  const { data: metadata } = useAccountMetadataForManagement();
  const { data: entitlements } = useAccountEntitlementsForManagement();

  const flagOverrides = metadata?.userFeatureFlagOverrides ?? [];
  const entitlementOverrides = entitlements?.user_override_keys ?? [];

  if (flagOverrides.length === 0 && entitlementOverrides.length === 0) {
    return null;
  }

  const showHeaders =
    flagOverrides.length > 0 && entitlementOverrides.length > 0;

  return (
    <Tooltip
      title="Active user overrides"
      contentProps={{ side: "bottom", align: "start" }}
      content={
        <div className="flex flex-col gap-2">
          {flagOverrides.length > 0 && (
            <div>
              {showHeaders && (
                <div className="font-semibold">Feature flags</div>
              )}
              <OverrideList keys={flagOverrides} />
            </div>
          )}
          {entitlementOverrides.length > 0 && (
            <div>
              {showHeaders && <div className="font-semibold">Entitlements</div>}
              <OverrideList keys={entitlementOverrides} />
            </div>
          )}
        </div>
      }
    >
      <button
        type="button"
        aria-label="Active user overrides"
        className={twMerge(
          "flex cursor-pointer items-center rounded-md p-2",
          className,
        )}
      >
        <Info size={16} />
      </button>
    </Tooltip>
  );
};
